<mat-card
  [attr.data-testid]="cardDataTestid()"
  [class]="{
    'gray-card': isAbandoned(),
    active: isActive(),
    collapsed: collapsed()
  }"
  class="user-card">
  @let lastMessage = (lastMessageService.lastMessageDict$ | async)!.get(roomId());
  @if (isDeletionDialog()) {
    <mat-checkbox
      class="checkbox tim-checkbox"
      (click)="$event.stopPropagation()"
      (change)="onCheckboxChange($event)"
      (keydown)="$event.stopPropagation()"></mat-checkbox>
  }
  @if (lastMessage) {
    @if (getJoinedMembers().length === 2) {
      @let otherRoomMemberId = getOtherRoommemberId(getJoinedMembers());
      <app-user-icon
        [userId]="lastMessage?.senderId || getOtherRoommemberId(getJoinedMembers())"
        class="avatar-icon"
        [presenceStatus]="presenceService.getPresence(otherRoomMemberId)"
        [scaleForPinned]="false"></app-user-icon>
    } @else {
      @let roomAvatar = (userService.userCache | async)!.get(roomId());
      @if (roomAvatar) {
        <img class="avatar-icon" [src]="roomAvatar" alt="" />
      } @else {
        <mat-icon class="avatar-icon" svgIcon="default-user-icon"></mat-icon>
      }
    }
    @if (!collapsed()) {
      <div class="card-content" [class.deletion-dialog]="isDeletionDialog()">
        <mat-card-header [attr.data-testid]="cardHeaderDataTestid()" class="card-header">
          <mat-card-title [attr.data-testid]="cardTitleDataTestid()" class="card-title">
            <div class="clamp-text">
              {{ roomname }}
            </div>
          </mat-card-title>
          <div class="time-count-wrapper">
            @if (lastMessage.timestamp) {
              <span class="card-subtitle"
                >{{
                  DateUtils.isToday(lastMessage.timestamp)
                    ? (lastMessage.timestamp | date: 'HH:mm')
                    : (lastMessage.timestamp | date: 'dd.MM.yyyy')
                }}
              </span>
            }
            <app-counter-badge
              [dataTestId]="testIds.unreadMessageCount"
              [dataTestIdMention]="testIds.mention"
              class="unread-messages"
              [count]="lastMessage.unreadMessageCount"
              [isMentioned]="lastMessage.isMentioned"></app-counter-badge>
          </div>
        </mat-card-header>
      </div>
    }
  }
</mat-card>
